module.exports = __webpack_public_path__ + "static/media/loginPage2.d1683e14.png";